import i18n from '@/i18n'
import { formatBytes, formatDate, formatDateTime } from '@/services/utils'

export function bool(_: string | undefined, __: string, value: string) {
	if (value === 'true') return i18n.global.t('misc.yes')
	else if (value === 'false') return i18n.global.t('misc.no')
	return ''
}

export function date(_: string | undefined, __: string, value: string) {
	return formatDate(value)
}

export function dateTime(_: string | undefined, __: string, value: string) {
	return formatDateTime(value)
}

export function bytes(_: string | undefined, __: string, value: string) {
	return formatBytes(Number.parseInt(value), 2)
}
